export default __webpack_public_path__ + "static/media/order-list.dc562503.png";